import UpdateTemplateFields from "./UpdateTemplateFields"
export default UpdateTemplateFields